import Helpers from '../modules/Helpers'

/**
 * Add class to body if user is tabbing to navigate
 * 
 * @param {Object} event Keydown event
 */
const userTabbing = (event) => {
    if (event.keyCode === 9) {
        const body = document.querySelector('body')

        new Helpers(body).toggleClass('user-tabbing')

        window.removeEventListener('keydown', userTabbing)
    }
}

window.addEventListener('keydown', userTabbing)
